// Generated by ReScript, PLEASE EDIT WITH CARE


function options(autopauseOpt, autoplayOpt, backgroundOpt, bylineOpt, colorOpt, controlsOpt, dntOpt, loopOpt, mutedOpt, pipOpt, playsinlineOpt, portraitOpt, responsiveOpt, quality, speedOpt, texttrack, titleOpt, transparentOpt, param) {
  var autopause = autopauseOpt !== undefined ? autopauseOpt : false;
  var autoplay = autoplayOpt !== undefined ? autoplayOpt : false;
  var background = backgroundOpt !== undefined ? backgroundOpt : false;
  var byline = bylineOpt !== undefined ? bylineOpt : true;
  var color = colorOpt !== undefined ? colorOpt : "E30B17";
  var controls = controlsOpt !== undefined ? controlsOpt : true;
  var dnt = dntOpt !== undefined ? dntOpt : false;
  var loop = loopOpt !== undefined ? loopOpt : false;
  var muted = mutedOpt !== undefined ? mutedOpt : false;
  var pip = pipOpt !== undefined ? pipOpt : false;
  var playsinline = playsinlineOpt !== undefined ? playsinlineOpt : true;
  var portrait = portraitOpt !== undefined ? portraitOpt : true;
  var responsive = responsiveOpt !== undefined ? responsiveOpt : false;
  var speed = speedOpt !== undefined ? speedOpt : false;
  var title = titleOpt !== undefined ? titleOpt : true;
  var transparent = transparentOpt !== undefined ? transparentOpt : true;
  return {
          autopause: autopause,
          autoplay: autoplay,
          background: background,
          byline: byline,
          color: color,
          controls: controls,
          dnt: dnt,
          loop: loop,
          muted: muted,
          pip: pip,
          playsinline: playsinline,
          portrait: portrait,
          responsive: responsive,
          quality: quality,
          speed: speed,
          texttrack: texttrack,
          title: title,
          transparent: transparent
        };
}

var Player = {
  options: options
};

export {
  Player ,
}
/* No side effect */
